<template>
  <div v-bind:class="{ 'op--modal-container': true, hide: !show }" @click="close">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="driver-notes small-margin-v-s" @click.stop>
          <div class="title">{{ $t('rsvpEdit.driverNotes') }}</div>
          <form @submit.prevent="addNote">
            <textarea :placeholder="$t('rsvpEdit.typeNote')" class="field-text" v-model="notes"></textarea>
            <div v-bind:class="{ 'error-message margin-b-s': true, hide: !error.show }">{{ error.message }}</div>
            <button class="op-btn btn-block btn-success btn-lg">{{ $t('rsvpEdit.saveNote') }}</button>
            <a href="javascript:;" class="remove-btn" @click="removeNote">{{ $t('rsvpEdit.removeNote') }}</a>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'driver-notes',
  data () {
    return {
      notes: '',
      error: {
        show: false,
        message: this.$t('rsvpEdit.emptyNotes')
      }
    }
  },
  computed: {
    show () { return this.$store.state.rsvpEdit.driverNotes.show }
  },
  methods: {
    close () { this.$store.commit('rsvpEdit/hideDriverNotes') },
    addNote () {
      let self = this
      self.error.show = false
      if (self.notes === '') {
        self.error.show = true
        return
      }
      self.$store.commit('rsvpEdit/setEditedNotes', self.notes)
      self.close()
    },
    removeNote () {
      this.$store.commit('rsvpEdit/setEditedNotes', null)
      this.close()
    }
  },
  watch: {
    show (value) {
      if (!value) {
        return
      }
      let self = this
      self.error.show = false
      self.notes = ''
      if (self.$store.state.rsvpEdit.editedRsvp.notes !== null) {
        self.notes = self.$store.state.rsvpEdit.editedRsvp.notes
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.driver-notes {
  background-color: #fff;
  max-width: 350px;
  margin: 10px auto;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);

  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 15px;
  }

  & textarea {
    resize: none;
    height: 100px;
  }
}

.remove-btn {
  text-align: center;
  margin-top: 15px;
  display: block;
  color: #cb8112;
}

.error-message {
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  color: #fff;
  padding: 5px;
  border-radius: 3px;
  background-color: #EB5837;
  display: block;
  &.hide { display: none; }
}
</style>



// WEBPACK FOOTER //
// DriverNotes.vue?60c868b1